/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState }  from 'react';     
import { Button } from 'primereact/button'; 

const FieldButton =  (props) => {
    
    const errorMessageStyle = {
      padding: '0 1rem'
    }

    const onClick = (e) => {  
        if (props.onClick !== null && typeof(props.onClick) === 'function'){
            props.onClick(e);
        } 
    } 
    
    const isFormFieldInValid = (name) => !!(typeof(props.errors) !== 'undefined' && props.errors !== null && props.errors[name]);
    
    const getFormErrorMessage = (name) => {          
        return isFormFieldInValid(name) && <small className="p-error">{props.errors[name].message}</small>;
    };
    
      return (  
        <>   
          <Button
            key={props.keyName? props.keyName : null}   
            hidden={props.hidden}
            label={props.label}             
            className={`${props.className} ${isFormFieldInValid(props.name) === true ? 'text-danger' : ''}`}
            onClick={onClick} 
            disabled={props.disabled}
            style={props.style}
            icon={props.icon}
            tooltip={props.tooltip}
            title={props.title}
            iconPos={props.iconPos? props.iconPos : 'left'}
          >
            {props.children}
          </Button>
          { 
            isFormFieldInValid(props.name) && (
              <p style={errorMessageStyle}>
                {getFormErrorMessage(props.name)}
              </p>
            )
          } 
        </> 
      )
}   
    
export default FieldButton; 
